import React from 'react';
import {observer} from "mobx-react";
import styles from "./seperated-cards-list.module.scss";
import classNames from "classnames";
import {SeperatedCardsListCard} from "./seperated-cards-list.card";

export const SeperatedCardsList = observer(({values, terms, className}) => {
  if (!values?.length > 0) {
    return null;
  }
  return <div className={classNames(styles.main_stats_card_container, styles.main_details_container, className)}>
    {
      values?.map((stat, index: Number) => <SeperatedCardsListCard key={index} item={stat} terms={terms}/>)
    }
  </div>

});